import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getActiveGame } from "../../utils/activeGame";

export default function ActiveGameFloat() {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeGame, setActiveGame] = useState(() => getActiveGame());
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const onStart = () => {
      setActiveGame(getActiveGame());
      setDismissed(false);
    };
    const onEnd = () => {
      setActiveGame(null);
      setDismissed(false);
    };
    window.addEventListener("pixyquiz:game-start", onStart);
    window.addEventListener("pixyquiz:game-end", onEnd);
    return () => {
      window.removeEventListener("pixyquiz:game-start", onStart);
      window.removeEventListener("pixyquiz:game-end", onEnd);
    };
  }, []);

  // Réaffiche le flottant à chaque changement de page (sauf page jeu)
  useEffect(() => {
    if (!location.pathname.startsWith("/game-quiz/")) {
      setDismissed(false);
    }
  }, [location.pathname]);

  // Caché sur la page de jeu elle-même
  if (location.pathname.startsWith("/game-quiz/")) return null;
  if (!activeGame || dismissed) return null;

  const handleReturn = () => {
    navigate(`/game-quiz/${activeGame.slug}`);
  };

  const handleNewGame = () => {
    window.dispatchEvent(new CustomEvent("openQuickPlay"));
  };

  return (
    <div className="fixed left-4 top-28 z-[150] w-60 overflow-hidden rounded-2xl border border-emerald-200 bg-white/95 shadow-[0_8px_32px_rgba(24,48,74,0.15)] backdrop-blur-xl">
      {/* Header */}
      <div className="flex items-center justify-between bg-gradient-to-r from-pixy-green/10 to-pixy-blue/10 px-3 py-2">
        <div className="flex items-center gap-2">
          <span className="flex h-6 w-6 items-center justify-center rounded-full bg-gradient-to-br from-pixy-green to-pixy-blue text-[11px]">
            🎮
          </span>
          <span className="text-xs font-black uppercase tracking-[0.18em] text-pixy-ink">
            Partie en cours
          </span>
        </div>
        <button
          type="button"
          onClick={() => setDismissed(true)}
          className="flex h-5 w-5 items-center justify-center rounded-full text-slate-400 transition hover:bg-slate-100 hover:text-slate-600"
          aria-label="Masquer"
        >
          ×
        </button>
      </div>

      {/* Catégorie */}
      <div className="px-3 pt-2 pb-1">
        <p className="text-[11px] text-slate-400 uppercase tracking-[0.16em]">Catégorie</p>
        <p className="mt-0.5 text-sm font-bold text-pixy-ink truncate">
          {activeGame.categoryName || activeGame.slug}
        </p>
      </div>

      {/* Boutons */}
      <div className="flex flex-col gap-1.5 px-3 pb-3 pt-2">
        <button
          type="button"
          onClick={handleReturn}
          className="w-full rounded-xl bg-gradient-to-r from-pixy-green to-pixy-blue py-2 text-xs font-bold uppercase tracking-[0.18em] text-white shadow-sm shadow-sky-300/30 transition hover:-translate-y-0.5 hover:shadow-sky-300/50"
        >
          Retourner dans la partie
        </button>
        <button
          type="button"
          onClick={handleNewGame}
          className="w-full rounded-xl border border-slate-200 bg-white py-2 text-xs font-semibold text-slate-600 transition hover:border-pixy-blue/30 hover:bg-pixy-sky hover:text-pixy-blue"
        >
          Commencer une nouvelle partie
        </button>
      </div>
    </div>
  );
}
